import { SaleStatus } from '@/types/api/sale';
import { saleStatusBackgroundColorMapping, saleStatusNameMapping } from '@/utils/sale';

interface SaleStatusProps {
  status: SaleStatus;
}

export default function SaleStatusDisplay({ status }: SaleStatusProps) {
  return (
    <div
      className={`text-sm inline-flex font-medium rounded-full text-center px-2.5 py-1 ${saleStatusBackgroundColorMapping[status]}`}
    >
      {saleStatusNameMapping[status]}
    </div>
  );
}
